module.exports = __webpack_public_path__ + "static/media/semi_conductors_open_graph.fee1417e.jpg";